import React, { Component } from "react";
import ReactResizeDetector from "react-resize-detector";
import PropTypes from "prop-types";

class BrowserResizeDetector extends Component {
  static propTypes = {
    onResize: PropTypes.func.isRequired
  };

  render() {
    const { onResize } = this.props;

    return (
      <div
        style={{
          position: "fixed",
          width: "50dvw",
          height: "50dvh",
          top: 0,
          zIndex: -100,
          left: "25dvw"
        }}
      >
        <ReactResizeDetector handleWidth handleHeight onResize={onResize} />
      </div>
    );
  }
}

export default BrowserResizeDetector;
